var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalhaLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 208,
    viewBox: "0 0 312 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 208,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2807_476871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.47 92.45L119.77 28.93C117.8 25.7 113.1 25.7 111.13 28.93L72.44 92.45C72.29 92.7 72.17 92.95 72.06 93.21C71.21 94.89 70.81 96.42 70.78 96.51C68.4 103.79 67.8 111.7 69.36 119.67C71.02 128.13 74.92 135.61 80.35 141.65C81.09 142.47 80.43 143.77 79.32 143.68C75.75 143.39 72.83 142.49 70.68 141.57C69.53 141.08 68.54 142.49 69.36 143.42C80.85 156.39 106.96 156.79 106.96 156.79C108.29 157.06 108.92 155.26 107.68 154.73C93.48 148.74 82.54 136.35 79.44 120.52C78.01 113.24 78.4 106 80.29 99.25C80.39 98.88 80.74 98.61 81.12 98.65C81.73 98.71 82.29 99.22 82.22 99.98C81.78 105.28 83.61 111.29 86.01 109.94C86.52 109.65 86.82 109.1 86.84 108.52C86.95 105.47 87.51 102.69 88.46 100.13H154.15C158.1 100.13 160.52 95.81 158.47 92.44V92.45Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46 90.98C116.76 90.98 117.95 90.56 118.92 89.84C120.34 88.78 121.26 87.09 121.26 85.19C121.26 81.99 118.67 79.39 115.47 79.39C113.24 79.39 111.3 80.65 110.34 82.49C109.92 83.3 109.68 84.21 109.68 85.19C109.68 88.39 112.28 90.98 115.48 90.98H115.46Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68 50.88L110.4 57L112.17 72.11C112.27 72.9 112.93 73.5 113.73 73.5H117.31C118.11 73.5 118.78 72.9 118.87 72.11L121.24 50.87C121.28 50.52 121.26 50.19 121.2 49.86C120.91 48.32 119.56 47.12 117.89 47.12H113.04C111.02 47.12 109.46 48.88 109.69 50.89L109.68 50.88Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.23 170.12C234.23 172.19 230.2 173.95 216.25 174.52C215.47 174.55 214.84 175.21 214.85 175.99V176.01C214.85 178.55 199.58 180.61 180.75 180.61C161.92 180.61 146.66 178.55 146.66 176.01C146.66 175.95 146.66 175.89 146.69 175.83C147.23 173.89 142.8 173.2 140.78 173.06C128.95 172.23 124.59 169.54 124.59 167.97C124.59 167.06 127.18 166.22 131.65 165.5C133.08 165.28 133.84 163.66 133.08 162.43C127.04 152.6 123.39 139.95 123.39 126.12C123.39 94.86 141.96 69.52 164.86 69.52C165.93 69.52 166.98 69.59 168.02 69.7C169.24 69.59 170.46 69.52 171.7 69.52H195.78C202.4 69.52 208.71 71.08 214.46 73.91C216.79 75.05 219.04 76.41 221.17 77.96C234.93 87.93 244.1 105.77 244.1 126.12C244.1 141.2 239.05 154.9 230.83 165.04C230.2 165.83 230.52 167 231.46 167.37C233.52 168.16 234.22 169.07 234.22 170.11L234.23 170.12Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06 163.37C174.066 163.37 185.42 146.693 185.42 126.12C185.42 105.547 174.066 88.87 160.06 88.87C146.054 88.87 134.7 105.547 134.7 126.12C134.7 146.693 146.054 163.37 160.06 163.37Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06 160.74C147.53 160.74 137.34 145.21 137.34 126.13C137.34 107.05 147.53 91.51 160.06 91.51C172.59 91.51 182.78 107.04 182.78 126.13C182.78 145.22 172.59 160.74 160.06 160.74Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.96 140.87C170.958 140.87 175.82 134.266 175.82 126.12C175.82 117.974 170.958 111.37 164.96 111.37C158.962 111.37 154.1 117.974 154.1 126.12C154.1 134.266 158.962 140.87 164.96 140.87Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.96 121.93C166.136 121.93 167.09 120.632 167.09 119.03C167.09 117.428 166.136 116.13 164.96 116.13C163.784 116.13 162.83 117.428 162.83 119.03C162.83 120.632 163.784 121.93 164.96 121.93Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.54 127.21C171.716 127.21 172.67 125.912 172.67 124.31C172.67 122.708 171.716 121.41 170.54 121.41C169.364 121.41 168.41 122.708 168.41 124.31C168.41 125.912 169.364 127.21 170.54 127.21Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.37 127.21C160.546 127.21 161.5 125.912 161.5 124.31C161.5 122.708 160.546 121.41 159.37 121.41C158.194 121.41 157.24 122.708 157.24 124.31C157.24 125.912 158.194 127.21 159.37 127.21Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56 134.94C169.736 134.94 170.69 133.642 170.69 132.04C170.69 130.438 169.736 129.14 168.56 129.14C167.384 129.14 166.43 130.438 166.43 132.04C166.43 133.642 167.384 134.94 168.56 134.94Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.35 134.94C162.526 134.94 163.48 133.642 163.48 132.04C163.48 130.438 162.526 129.14 161.35 129.14C160.174 129.14 159.22 130.438 159.22 132.04C159.22 133.642 160.174 134.94 161.35 134.94Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.53 162.66C202.65 152.8 206.34 140.05 206.34 126.12C206.34 101.87 195.16 81.17 179.45 73.12",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.25 170.09L140.53 157.47L137.49 156.63L135.25 170.09Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.945 158.817C143.278 157.625 141.711 156.147 139.445 155.514C137.179 154.881 135.072 155.334 134.739 156.526C134.407 157.717 135.974 159.196 138.24 159.829C140.506 160.461 142.613 160.008 142.945 158.817Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55 170.58L123.88 160.81L121.83 162.62L130.55 170.58Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.524 163.588C126.051 162.239 126.714 160.494 126.005 159.691C125.295 158.888 123.482 159.331 121.955 160.68C120.427 162.029 119.764 163.774 120.474 164.577C121.183 165.38 122.996 164.937 124.524 163.588Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.07 170.28L238.47 164.62L236.87 162.4L228.07 170.28Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.367 166.851C240.237 166.226 239.979 164.377 238.791 162.722C237.603 161.066 235.934 160.23 235.063 160.855C234.193 161.48 234.451 163.329 235.639 164.984C236.827 166.64 238.496 167.475 239.367 166.851Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.1 113.76C227.2 115.41 226.2 116.91 225.13 118.23C223.83 119.84 224.34 122.25 226.16 123.24C227.98 124.23 230.26 123.82 231.59 122.23C232.76 120.84 233.86 119.22 234.84 117.42C236.63 114.13 237.68 110.8 237.99 107.93C238.15 106.4 237.38 104.93 236.03 104.19C233.98 103.07 231.38 104.2 230.88 106.49C230.38 108.78 229.44 111.29 228.1 113.76Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.96 115.16L233.39 119.35",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.17 108.78L236.6 112.97",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.18 77.96C220.35 78.78 219.55 79.67 218.78 80.65C217.6 82.12 216.62 83.64 215.83 85.13C214.85 86.96 212.44 87.42 210.81 86.13C209.74 85.27 209.15 83.99 209.15 82.69C209.15 82.02 209.3 81.36 209.62 80.74C210.45 79.12 211.5 77.47 212.78 75.87C213.32 75.18 213.9 74.52 214.49 73.9C216.82 75.04 219.07 76.4 221.2 77.95L221.18 77.96Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.93 82.25L211.56 77.97",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.54 144.51C219.28 143.29 218.19 142.01 217.28 140.73C216.16 139.16 213.88 139.02 212.53 140.4C211.19 141.78 210.98 143.93 212.07 145.52C213.03 146.92 214.2 148.31 215.57 149.63C218.07 152.06 220.79 153.83 223.29 154.83C224.62 155.36 226.14 155.04 227.13 154.01C228.64 152.45 228.28 149.84 226.36 148.82C224.44 147.8 222.42 146.33 220.54 144.51Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.57 143.14L214.21 147.85",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.49 147.61L219.13 152.33",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.367 110.936C157.101 110.202 155.727 107.637 153.298 105.208C150.869 102.779 148.305 101.405 147.571 102.139C146.837 102.874 148.211 105.438 150.64 107.867C153.069 110.296 155.633 111.67 156.367 110.936Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.304 147.142C155.733 144.713 157.107 142.149 156.372 141.415C155.638 140.68 153.074 142.054 150.645 144.483C148.216 146.912 146.842 149.477 147.576 150.211C148.31 150.945 150.874 149.571 153.304 147.142Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.924 150.372C169.647 147.014 169.41 144.114 168.395 143.896C167.379 143.678 165.971 146.223 165.249 149.582C164.526 152.94 164.763 155.84 165.778 156.058C166.793 156.276 168.202 153.731 168.924 150.372Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.4 108.953C169.415 108.735 169.652 105.835 168.93 102.477C168.208 99.1182 166.799 96.5727 165.784 96.7911C164.769 97.0094 164.532 99.909 165.254 103.267C165.977 106.626 167.385 109.171 168.4 108.953Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.76 128.82C149.195 128.82 151.98 127.978 151.98 126.94C151.98 125.902 149.195 125.06 145.76 125.06C142.325 125.06 139.54 125.902 139.54 126.94C139.54 127.978 142.325 128.82 145.76 128.82Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2807_476871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176.61,
    height: 155.1,
    fill: "white",
    transform: "translate(68 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalhaLoading);
export default __webpack_public_path__ + "static/media/falha-loading.8dd37c5b.svg";
export { ForwardRef as ReactComponent };